import { useDeviceFlowAuthStore } from './DeviceFlowAuth';
import { useAuthStore } from './stores';

export interface FetcherError extends Error {
    info?: unknown;
    status?: number;
}

export default async function OrvalDjangoFetcher<T>(route: string, options: RequestInit): Promise<T> {
    const cloak = useAuthStore.getState().keyCloak;

    let token;
    if (!cloak) {
        token = await useDeviceFlowAuthStore.getState().updateToken();
    } else {
        await cloak.updateToken(5);
        if (!cloak.token) {
            throw new Error('Unauthorized');
        }
        token = cloak.token;
    }

    const headers = new Headers(options.headers);

    if (headers.get('authorization') !== 'undefined') {
        headers.append('Authorization', `Bearer ${token}`);
    }

    if (headers.get('Content-Type') === 'undefined') {
        headers.delete('Content-Type');
    }

    const res = await fetch(route, {
        ...options,
        headers,
    });

    if (!res.ok) {
        const error: FetcherError = new Error('An error occurred while fetching the data.');
        try {
            error.info = await res.json();
        } catch {
            error.info = await res.text();
        }
        error.status = res.status;
        throw error;
    }

    if (res.status === 204) {
        return {} as T;
    }

    try {
        return (await res.json()) as T;
    } catch {
        throw new Error('An error occurred while parsing the response.');
    }
}
